import classes from "./TermsRoute.module.css";
import { Link } from "react-router-dom";

const TermsRoute = () => {
  return (
    <div className={classes.modal}>
      <div className={`${classes.background_wrapper}`}>
        <div className={`${classes.wrapper}`}>
          <div className={classes.info_container}>
            <p className={classes.info}>Privacy Policy</p>
            <p className={classes.info_brief}>Last Updated: 23-March-2025</p>
          </div>
        </div>
      </div>

      <div className={classes.privacy_content}>
        <section className={classes.section}>
          <p className={classes.p}>
          Welcome to <strong>ChatBuddies</strong>, a social networking app
            that helps users discover new people, make friends, and engage in
            meaningful conversations. By accessing or using ChatBuddies, you
            agree to comply with these Terms and Conditions. If you do not
            agree, please refrain from using the app.
          </p>
        </section>
        <section className={classes.section}>
          <h2 className={classes.h2}>1. Information We Collect</h2>
          <h3 className={classes.h3}>1.1. Personal Information</h3>
          <p>When you create an account, we may collect:</p>
          <ul>
            <li>
              <strong>Name:</strong> Your Name for account
              creation and community interactions.
            </li>
            <li>
              <strong>Email Address:</strong> Used for account registration,
              login, and account-related notifications.
            </li>
            <li>
              <strong>Password:</strong> Used to protect your account.
            </li>
          </ul>
          <h3 className={classes.h3}>1.2. Permissions & Data Usage</h3>
          <p className={classes.p}>
           By using ChatBuddies, you grant the app access to the following permissions:
          </p>
          <ul>
            <li>
              <strong>Camera & Microphone:</strong> Accessed only when you initiate a video or voice call.
            </li>
            <li>
              <strong>Gallery & Files:</strong> Required only when you choose to upload or share photos and videos.
            </li>
          </ul>
        </section>
        <section className={classes.section}>
          <h2 className={classes.h2}>2. User Conduct & Safety</h2>
          <p className={classes.p}>
          Users are expected to engage respectfully. Misuse, harassment, or
            inappropriate content can lead to account suspension. Other users
            can <strong>report</strong> and <strong>block</strong> profiles if
            they violate our policies.
          </p>
        </section>
        <section className={classes.section}>
          <h2 className={classes.h2}>3. Security & Privacy</h2>
          <p className={classes.p}>
          We take appropriate technical and organizational measures to protect
            your information from unauthorized access, loss, misuse, or
            alteration. However, no data transmission over the internet is
            entirely secure. Please protect your account by choosing a strong
            password and keeping it confidential.
          </p>
        </section>
        <section className={classes.section}>
          <h2 className={classes.h2}>4. Your Choices and Rights</h2>
          <ul>
            <li>
              <strong>Data Deletion:</strong> You may request the deletion of
              your account and data by visiting{" "}
              <Link to="/delete-account" style={{color:"blue"}}>Delete Account Page</Link>
            </li>
          </ul>
        </section>
        <section className={classes.section}>
          <h2 className={classes.h2}>5. Changes to This Privacy Policy</h2>
          <p className={classes.p}>
            We may update this Privacy Policy periodically to reflect changes in
            our practices, legal requirements, or for other operational reasons.
            We will notify you of any significant changes by posting the new
            Privacy Policy on this page and updating the "Last Updated" date.
          </p>
        </section>

        <section className={classes.section}>
          <h2 className={classes.h2}>6. Contact Us</h2>
          <p className={classes.p}>
            If you have any questions, concerns, or requests regarding this
            Privacy Policy or your personal information, please contact us at:
          </p>
          <p className={classes.p}>
            {/* <strong>MovieFlix.Visiontrek</strong> */}
            {/* <br></br> */}
            Email: info@visiontrek.in
            <br></br>
            Address: Phase 8 B, E 195, Phase 8B, Industrial Area, Sector 74,
            Sahibzada Ajit Singh Nagar, Punjab 160055
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsRoute;
